import { AppSwitcherConfig } from './types';
import { cloneDeep } from '~/utils/object';

export type BatchElementType = null | AppSwitcherConfig[];
export const EMPTY_BATCH = [] as BatchElementType[];

export const menuFilter =
  (featureFlags: string[]) =>
  (item: AppSwitcherConfig): boolean => {
    if (!item.url) {
      return false;
    }
    if (item.featureFlags.length === 0) {
      return true;
    }
    const matches = item.featureFlags.filter((flag: string) =>
      featureFlags.includes(flag),
    );
    return matches.length > 0;
  };

export const batchByGroup = (
  batches: BatchElementType[],
  config: AppSwitcherConfig,
): BatchElementType[] => {
  const newBatches = cloneDeep(batches);
  const { group } = config;

  if (Array.isArray(newBatches[group])) {
    const target = newBatches[group];
    target.push(config);
  } else {
    newBatches[group] = [config];
  }
  return newBatches;
};

export const sortByGroup = (a: AppSwitcherConfig, b: AppSwitcherConfig) =>
  a.group > b.group ? -1 : 1;
